module.exports = __webpack_public_path__ + "media/barcelona musica/hall_side-cc3b9a28.jpg";